var app = angular.module("leonardo");

var PropertyReportFilter = function ($scope, $state, FilterService) {
  $scope.filterService = FilterService;
  $scope.only_account = $state.current.only_filter_account;

  $scope.refresh = function () {
    $scope.account_reports = FilterService.getFilter('account_reports');
    $scope.managed_by_reports = FilterService.getFilter('managed_by_reports');
    $scope.portfolio_reports = FilterService.getFilter('portfolio_reports');
    $scope.property_reports = FilterService.getFilter('property_reports');
    $scope.group_reports = FilterService.getFilter('group_reports');
  };

  if (FilterService.initialized) {
    $scope.refresh();
  }
  else {
    $scope.$on('filter-service:initiated', $scope.refresh);
  }

};

app.controller('PropertyReportFilter', ['$scope', '$state', 'FilterService', PropertyReportFilter]);
